import { useState, useEffect } from 'react'

function getWindowDimensions() {
  if (typeof window === 'undefined') {
    return { width: 0, height: 0 }
  }
  const { innerWidth: width, innerHeight: height } = window
  return {
    width,
    height,
  }
}

function getElementDimensionById(id) {
  if (typeof document === 'undefined') {
    return { width: null, height: null }
  }
  const el = document.getElementById(id)
  if (!el) {
    return { width: null, height: null }
  }
  const { offsetWidth: width = null, offsetHeight: height = null } = el
  return {
    width,
    height,
  }
}

export function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  )

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions())
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return {
    ...windowDimensions,
    getElementDimensionById,
  }
}
